import { render, staticRenderFns } from "./generalsettings.vue?vue&type=template&id=7c6a3290&scoped=true"
import script from "./generalsettings.vue?vue&type=script&lang=js"
export * from "./generalsettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c6a3290",
  null
  
)

export default component.exports